module.exports = {"540224100":"萨迦镇","540224101":"吉定镇","540224200":"木拉乡","540224201":"查荣乡","540224202":"拉洛乡","540224203":"赛乡","540224204":"扯休乡","540224205":"扎西岗乡","540224206":"雄玛乡","540224207":"麻布加乡","540224208":"雄麦乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540224.json
// module id = 2495
// module chunks = 0